<span
  mat-dialog-title
  *ngIf="videoUrl()"
  [style.color]="liveConfig()?.textColor"
  [style.backgroundColor]="liveConfig()?.backgroundColor"
  style="margin: 0"
>
  {{ liveConfig()?.title }}
</span>
<mat-dialog-content
  [style.backgroundColor]="liveConfig()?.backgroundColor"
  [style.color]="liveConfig()?.textColor"
>
  <iframe
    *ngIf="videoUrl()"
    class="rumble"
    width="100%"
    height="315"
    [src]="videoUrl()"
    frameborder="0"
    allowfullscreen
  ></iframe>
  <div
    class="notification-message"
    *ngIf="!videoUrl()"
    [innerHtml]="textMessage()"
  ></div>
</mat-dialog-content>
<mat-dialog-actions [style.backgroundColor]="liveConfig()?.backgroundColor">
  <button mat-flat-button (click)="hideDialog()">{{ liveConfig()?.button?.text }}</button>
</mat-dialog-actions>
